import { ArrowLeft, FileText, Film } from 'lucide-react';

export default function Preview({ file, serveUrl, onBack }) {
  if (!file || !serveUrl) {
    return (
      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <div className="animate-spin w-8 h-8 border-2 border-gray-400 border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col h-full bg-white">
      {/* Top bar */}
      <div className="h-10 flex items-center justify-between px-4 border-b border-gray-200 flex-shrink-0">
        <div className="flex items-center space-x-2 min-w-0">
          <button
            onClick={onBack}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0"
          >
            <ArrowLeft size={16} className="text-gray-600" />
          </button>
          <span className="text-sm font-medium truncate">{file.base_name}</span>
        </div>
        <span
          className={`text-[10px] font-semibold px-1.5 py-0.5 rounded flex items-center space-x-1 flex-shrink-0 ${
            file.file_type === 'video'
              ? 'bg-blue-50 text-blue-700'
              : 'bg-red-50 text-red-700'
          }`}
        >
          {file.file_type === 'video' ? <Film size={10} /> : <FileText size={10} />}
          <span>{file.file_type === 'video' ? '视频' : 'PDF'}</span>
        </span>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden bg-gray-50">
        {file.file_type === 'video' ? (
          <video
            controls
            className="w-full h-full object-contain bg-black"
            src={serveUrl}
            key={serveUrl}
          />
        ) : (
          <iframe
            src={serveUrl}
            className="w-full h-full border-0"
            title={file.base_name}
          />
        )}
      </div>
    </div>
  );
}
